module.exports = __webpack_public_path__ + "static/img/12.57b3a5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/sp/12.png
// module id = raWS
// module chunks = 0